import React, { useMemo } from "react";
import { Session } from "utils/types";
import { Column } from "react-table";
import LazyDataTable from "components/LazyDataTable";
import SessionRow from "./SessionRow";
import { queryKeys, queryFns } from "repo/sessions";

const SessionsTable: React.FC = () => {
  const columns: Column<Session>[] = useMemo(
    () => [
      {
        accessor: "id",
        disableSortBy: true,
        Cell: ({ row: { original } }: any) => <SessionRow {...original} />
      },
      {
        Header: "Title",
        accessor: "title"
      },
      {
        Header: "Coach First Name",
        id: "coach_first_name",
        accessor: row => row.coach.first_name
      },
      {
        Header: "Coach Last Name",
        id: "coach_last_name",
        accessor: row => row.coach.last_name
      },
      {
        Header: "Start Time",
        accessor: "start_time"
      },
      {
        Header: "End Time",
        accessor: "end_time"
      }
    ],
    []
  );

  //return <DataTable data={data} columns={columns} tableTitle="Your Calls" />;
  return (<LazyDataTable columns={columns} dataKey={queryKeys.data(true)} dataFn={queryFns.data} tableTitle="Your Calls" />);

};

export default SessionsTable;
